'use strict'

const { version } = require('../package.json')

module.exports = { version }
